<section
  id="features"
  class="relative overflow-hidden py-24 px-6 lg:px-12"
  style="background: linear-gradient(to bottom, var(--theme-bg), var(--theme-bg-alt))"
  aria-label="Platform features"
  *transloco="let t"
>
  <div class="dot-accent-tr" aria-hidden="true"></div>

  <div class="max-w-7xl mx-auto">
    <!-- Heading -->
    <div class="text-center mb-14">
      <div class="section-label justify-center reveal">{{ t('features.sectionLabel') }}</div>
      <h2
        class="font-display font-bold reveal stagger-1"
        style="font-size:clamp(1.75rem,4vw,3rem);letter-spacing:-0.025em"
      >
        {{ t('features.sectionTitle') }}<br />
        <span class="gradient-text">{{ t('features.sectionSub') }}</span>
      </h2>
    </div>

    <!-- Uniform 3×2 grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      @for (card of infoCards; track card.title; let i = $index) {
        <app-info-card
          [title]="t(card.title)"
          [description]="t(card.description)"
          [imageSrc]="card.imageSrc"
          [imageAlt]="card.imageAlt"
          [index]="i"
          class="reveal block"
          [class]="'stagger-' + (i + 1)"
        />
      }
    </div>
  </div>
</section>
